// libs
import React from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'
import Page from './containers/page'
import { changeRecipient, resetMultiRecipients } from './actions/Actions'
import externalRedirect from './utils/homepage-external-redirect'
import Events from '../lib/analytics/eventTags'

import TabContainer from './containers/tabs'

import validateRoutes from './utils/validate-routes'

import serverProps from './utils/serverProps'
import { filterTabs, getDefaultTab } from './utils/homepage-filter-tabs'

import {
  Send,
  Request,
  ContactList,
  MiscFunnel,
  FundingOptionSelector,
  Preview,
  SendSuccess,
  BuySuccess,
  BlockContactList,
} from './lazy-components'

import content from 'pp-react-l10n'
const i18n = content('transfer/homePage')

const paths = {
  main: '/myaccount/transfer/homepage',
  send: '/myaccount/transfer/homepage/pay',
  request: '/myaccount/transfer/homepage/request',
  contacts: '/myaccount/transfer/homepage/contact-list',
  more: '/myaccount/transfer/homepage/more',
}

/*
 *  an array of objects
 *  label: the navigation link text
 *  path: the link to go to
 *  comp: the react component to display
 *  analytics: the pagename for the link-to
 */
const PANES = [
  {
    type: {
      feature: 'send',
    },
    label: i18n('navbar.send.label'),
    path: paths.send,
    comp: Send,
    onClickAction: dispatch => {
      Events.updateCommonProps({
        sub_flow: 'send_money',
      })
      dispatch(changeRecipient(''))
    },
    datanemo: 'main:p2p:tab-send',
    analytics: {
      pagename: 'main:p2p:tab-send::start:node::',
      pagegroup: 'main:p2p:tab-send::start',
      extra: {
        linkname: 'linkTabSend',
      },
    },
  },
  {
    type: {
      feature: 'request',
    },
    label: i18n('navbar.request.label'),
    path: paths.request,
    comp: Request,
    onClickAction: dispatch => {
      Events.updateCommonProps({
        sub_flow: 'request_money',
      })
      dispatch(resetMultiRecipients())
    },
    datanemo: 'main:p2p:tab-request',
    analytics: {
      pagename: 'main:p2p:tab-request::start:node::',
      pagegroup: 'main:p2p:tab-request::start',
      extra: {
        linkname: 'linkTabRequest',
      },
    },
  },
  {
    type: {
      feature: 'contacts',
    },
    label: i18n('navbar.contacts.label'),
    path: paths.contacts,
    comp: ContactList,
    datanemo: 'main:p2p:tab-contacts',
    analytics: {
      pagename: 'main:p2p:tab-contacts:node::',
      pagegroup: 'main:p2p:tab-contacts',
      extra: {
        linkname: 'linkTabContacts',
      },
    },
  },
  {
    type: {
      feature: 'more',
    },
    label: i18n('navbar.more.label'),
    path: paths.more,
    comp: MiscFunnel,
    datanemo: 'main:p2p:tab-more',
    analytics: {
      pagename: 'main:p2p:tab-more:node::',
      pagegroup: 'main:p2p:tab-more',
      extra: {
        linkname: 'linkTabMore',
      },
    },
  },
]

export default () => {
  const { featureEligibility } = serverProps
  return (
    <Route
      path={paths.main}
      render={props => homepageRoutes(PANES, featureEligibility)}
    />
  )
}

function homepageRoutes(panes, featureEligibility) {
  const filteredPanes = filterTabs(panes, featureEligibility)
  return (
    <Page>
      <Switch>
        <Route
          exact
          path={paths.main}
          render={() => (
            <TabContainer
              selected={getDefaultTab(filteredPanes)}
              panes={filteredPanes}
            />
          )}
        />
        {filteredPanes.map((pane, index) => {
          const dynamicProp = { exact: true }
          return (
            <Route
              {...dynamicProp}
              path={pane.path}
              render={() => (
                <TabContainer selected={index} panes={filteredPanes} />
              )}
            />
          )
        })}
        <Route
          path="/myaccount/transfer/homepage/send/select"
          render={props =>
            validateRoutes(props) || (
              <FundingOptionSelector {...props} unified={true} />
            )
          }
        />
        <Route
          path="/myaccount/transfer/homepage/send/preview"
          render={props => {
            return validateRoutes(props) || <Preview {...props} />
          }}
        />
        <Route
          path="/myaccount/transfer/homepage/send/success"
          render={props =>
            validateRoutes(props) || <SendSuccess {...props} unified={true} />
          }
        />

        <Route
          path="/myaccount/transfer/homepage/buy/select"
          render={props =>
            validateRoutes(props) || (
              <FundingOptionSelector {...props} unified={true} />
            )
          }
        />
        <Route
          path="/myaccount/transfer/homepage/buy/preview"
          render={props => {
            return validateRoutes(props) || <Preview {...props} />
          }}
        />
        <Route
          path="/myaccount/transfer/homepage/buy/success"
          component={props =>
            validateRoutes(props) || <BuySuccess {...props} unified={true} />
          }
        />
        <Route
          path="/myaccount/transfer/homepage/preview"
          component={props => {
            return validateRoutes(props) || <Preview {...props} />
          }}
        />
        <Route
          path="/myaccount/transfer/homepage/contact-list/blocked-contacts"
          component={() => {
            return <BlockContactList />
          }}
        />
        <Route
          path="/myaccount/transfer/homepage/external/:env?"
          render={props => externalRedirect(props)}
        />
        {/* we are retiring /homepage/send. Just in case anyone still hits that, we do the redirection */}
        <Redirect
          from="/myaccount/transfer/homepage/send"
          to="/myaccount/transfer/homepage/pay"
        />
      </Switch>
    </Page>
  )
}
